import { PureComponent } from 'react'
import _ from 'lodash'
import { PopoverImg } from '@vzmi/shp_shared_compo'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import styles from './index.css'

import VideoUploader from '../../../../../containers/Proposal/Common/VideoUploader'
import { FormRow } from '../../../../Common/Form'
import { Field } from '../../../../Common/forms'
import { IconPopoverLabel } from '../FormLabelTooltip/FormLabelTooltip'
import withProposalListingFormUploadFiles from '../../HOC/withProposalListingFormUploadFiles'
import { formatUploadedVideoFile, fileWithoutCircleProps } from '../Shared/util'

class SingleVideoUploaderField extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      isHover: false
    }
  }

  videoOnUpdate = (files) => {
    const { input } = this.props
    const file = _.get(files, '0', null)
    const formatedUploadedFile = formatUploadedVideoFile(file)
    input.onBlur(formatedUploadedFile)
    this.props.updateUploadFiles(file)
  }

  videoOnFinish = (files) => {
    const { input } = this.props
    const file = _.get(files, '0', null)
    const formatedUploadedFile = _.flow(
      formatUploadedVideoFile,
      fileWithoutCircleProps
    )(file)
    input.onChange(formatedUploadedFile)
    this.props.updateUploadFiles(fileWithoutCircleProps(file))
  }

  render () {
    const {
      input,
      className,
      index,
      ...props
    } = this.props
    const defaultThumbnail = _.get(input, 'value.thumbnail.url')

    // if has thumbnail and batch index exceed assigned amout, show thumbnail for lazyload instead of uploader
    return index > 25 && defaultThumbnail && !this.state.isHover
      ? (
        <img
          src={defaultThumbnail}
          className={styles.lazyloadThumbnail}
          // disable lazyload placeholder when hover
          onMouseOver={() => this.setState({ isHover: true })}
        />
      )
      : (
        <VideoUploader
          className={className}
          maxFile={1}
          defaultFileList={input.value}
          onUpdateFile={this.videoOnUpdate}
          onFinish={this.videoOnFinish}
          test={defaultThumbnail}
          {...props}
        />
      )
  }
}

export const SingleVideoUploaderFieldContainer = withProposalListingFormUploadFiles(SingleVideoUploaderField)

const Video = props => {
  const {
    fieldName = 'product.models[0].videos[0]',
    ...drillingProps
  } = props

  return (
    <div
      className={styles.Video}
      data-role='video'
    >
      <FormRow
        subTitle='(非必填)'
        label={(
          <IconPopoverLabel
            popoverContent={(
              <PopoverImg
                url={`${CDN}/img/tooltip_video.png`}
                width={500}
                height={500}
              />
            )}
          >
            賣場影片
          </IconPopoverLabel>
        )}
      >
        <Field
          name={fieldName}
          className={styles.productModalVideo}
          component={SingleVideoUploaderFieldContainer}
          {...drillingProps}
        />
      </FormRow>
    </div>
  )
}

export default Video
